import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PublicConfig } from './types';

export const ConfigContext = createContext<PublicConfig | undefined>(undefined);

export const ConfigProvider: React.FC<{ initialConfig?: PublicConfig }> = ({
  children,
  initialConfig,
}) => {
  const { data } = useQuery(
    ['config'],
    () =>
      fetch(new URL('/api/config', window.location.origin).href, { method: 'GET' }).then(
        (response) => {
          if (!response.ok) {
            console.error('Could not load config');
            return;
          }
          return response.json() as Promise<PublicConfig>;
        },
      ),
    {
      initialData: initialConfig,
      enabled: !initialConfig,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  return <ConfigContext.Provider value={data}>{children}</ConfigContext.Provider>;
};

export const useConfigContext = () => useContext(ConfigContext);
